/**
 * <Comente>
 */


Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.Rating = (function () {

    function TextField () {

        Monet.UI.Fields.Base.apply (this, arguments);

        this.createBaseStructure();

        this.input = null;
        this.value = 1;
        this.min = 0;
        this.max = 5;

        this.setMin = function (min) {
            this.min = min;
        };

        this.setMax = function (max) {
            this.max = max;
        };

        this.createElement = function (listener, dataContext) {

            this.starsContainer = document.createElement ('div');
            this.starsContainer.className = 'starsContainer'

            if (listener){
                this.starsContainer.setAttribute('onclick', listener)
            }

            if (dataContext) {
                this.starsContainer.setAttribute('id', dataContext.model.get('route').id);
                this.starsContainer.setAttribute('akey', dataContext.model.attributes.stop.key);
                this.starsContainer.setAttribute('tabname', Monet.Utils.GetTabName());
            }

            for (var index = this.min+1; index <= this.max; index++) {
                this.starsContainer.appendChild (this.createStar (index,listener));
            }

            this.rootEl.innerHTML = '';
            this.rootEl.appendChild (this.starsContainer);

        };

        this.createStar = function (index, listener) {

            const star = document.createElement('i')
            const starNumber = index - 1;

            if (starNumber >= this.value) {
                star.className = 'fa fa-star notSelectedStar';
            }
            else {
                star.className = 'fa fa-star selectedStar';
            }
            if (!listener && this.disabled === false) {
                star.addEventListener('click', (function (scope, index) {
                    return function () {
                        scope.setValue(index);
                        scope.createElement();
                    };
            }(this, index)));

            }
            return star;

        };

        this.getValue = function () {
            return this.value;
        };

        this.setValue = function (value) {
            if (value) {
                this.value = value;
            }
            else {
                this.value = 0;
            }
        };

        this.render = function (listener, dataContext) {

            this.createElement(listener, dataContext);
            return this.rootEl;

        };



    }

    return TextField;

}());